<template>
  <div class="group-setup">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="pa-5">
      <v-card-title dark>
        <h3 class="ma-2">Financial Statement</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <DatePicker
              :lable="
                'Date of approval of the board for monthly financial statement.'
              "
              v-model="form.date_of_approval_of_the_board"
              :setectVale="form.date_of_approval_of_the_board"
              @changeInput="form.date_of_approval_of_the_board = $event"
            ></DatePicker>
          </v-col>
           <v-col cols="6" md="6" sm="12">
            <DatePicker
              :lable="'Date of Submission to Cab. Treasurer'"
              v-model="form.date_of_submission_to_cab_treasurer"
              :setectVale="form.date_of_submission_to_cab_treasurer"
              @changeInput="form.date_of_submission_to_cab_treasurer = $event"
            ></DatePicker>
          </v-col>
          
        </v-row>
        <v-row>
         
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document1"
              prepend-icon="mdi-paperclip"
              label="Please upload pdf or image"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="success"
              depressed
              :disabled="loading || !form.date_of_approval_of_the_board"
              block
              @click="submit()"
              >Submit to Review</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import DatePicker from "@/components/shared/DatePicker";
import { FinancialStatement } from "../../../services/financial-statement-service";
import { checkError } from "@/config/errors.js";

export default {
  name: "groupSetUpFrom",

  components: { Alert, Snackbars, DatePicker },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      date_of_approval_of_the_board: null,
      date_of_submission_to_cab_treasurer: null,
      document1: null,
    },
  }),

  mounted() {},

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      this.loading = true;
      this.errors = null;
      this.snackbar = false;
      let fd = new FormData();
      fd.append("document1", this.form.document1);
      fd.append(
        "date_of_approval_of_the_board",
        this.form.date_of_approval_of_the_board
      );      
      fd.append(
        "date_of_submission_to_cab_treasurer",
        this.form.date_of_submission_to_cab_treasurer
      );
      fd.append("month", this.$route.params.month);
      fd.append("key", "FINANCIAL_STATEMENT");

      let data = fd;
      FinancialStatement.create(data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.succesMsg = "Your submission has been sent successfully";
            this.snackbar = true;
            this.$router.push("/activities/monthly"); 
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form = [];
    },
  },
};
</script>
